// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlPanel {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: white;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.buttonRow {
  display: flex;
  gap: 8px;
}

.controlRow {
  display: flex;
  gap: 4px;
  align-items: center;
}

.label {
  font-size: 12px;
  min-width: 140px;
}

.smallButton {
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/examples/networks-and-flows/sankey/sankey-zoom/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".controlPanel {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: white;\n  padding: 12px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.buttonRow {\n  display: flex;\n  gap: 8px;\n}\n\n.controlRow {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.label {\n  font-size: 12px;\n  min-width: 140px;\n}\n\n.smallButton {\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlPanel": `controlPanel`,
	"buttonRow": `buttonRow`,
	"controlRow": `controlRow`,
	"label": `label`,
	"smallButton": `smallButton`
};
export default ___CSS_LOADER_EXPORT___;
